module.exports = __webpack_public_path__ + "img/14ry_tp04.ad94fed8.jpg";